import { loadTossPayments, ANONYMOUS } from '@tosspayments/tosspayments-sdk';

// 환경 분기 — STAGING 은 라이브 키로 절대 못 가도록 코드 레벨에서 강제
const IS_STAGING = process.env.REACT_APP_ENV === 'staging';

// API 개별 연동 클라이언트 키 (loadTossPayments SDK와 매칭)
// ⚠️ TOSS_SECRET_KEY(Cloud Function 시크릿)와 같은 API KEY 행의 클라이언트 키여야 함
// STAGING 환경에서는 .env.local 에 live 키가 있어도 무시하고 무조건 테스트 키 사용
const CLIENT_KEY = IS_STAGING
  ? 'test_ck_QbgMGZzorzjLjEAG27E2rl5E1em4'
  : (process.env.REACT_APP_TOSS_CLIENT_KEY || 'test_ck_QbgMGZzorzjLjEAG27E2rl5E1em4');

// Cloud Function endpoint — STAGING 은 staging functions 호출
const PROJECT_ID = IS_STAGING
  ? 'test-83e89'
  : (process.env.REACT_APP_FIREBASE_PROJECT_ID || 'ieum-8fd99');
const REGION = 'us-central1';
const CONFIRM_URL = `https://${REGION}-${PROJECT_ID}.cloudfunctions.net/confirmTossPayment`;
const REFUND_URL = `https://${REGION}-${PROJECT_ID}.cloudfunctions.net/refundTossPayment`;

// 주문ID 생성 (영문/숫자/하이픈 6~64자, Toss 규격)
export const buildOrderId = (prefix = 'db') => {
  const t = Date.now();
  const rand = Math.random().toString(36).slice(2, 8);
  return `${prefix}-${t}-${rand}`;
};

// v1 → v2 메서드 매핑
const METHOD_MAP = {
  '카드': 'CARD',
  '계좌이체': 'TRANSFER',
  '가상계좌': 'VIRTUAL_ACCOUNT',
  '휴대폰': 'MOBILE_PHONE',
};

// 결제창 호출 (성공 시 successUrl 로 리다이렉트, 거기서 confirm 호출)
export const requestTossPayment = async ({
  amount,
  orderId,
  orderName,
  customerName,
  method = '카드',
}) => {
  const successUrl = `${window.location.origin}/payment/success`;
  const failUrl = `${window.location.origin}/payment/fail`;

  // v2 SDK — windowTarget: 'self' 로 같은 창 리다이렉트 (반응형)
  const tossPayments = await loadTossPayments(CLIENT_KEY);
  const payment = tossPayments.payment({ customerKey: ANONYMOUS });
  await payment.requestPayment({
    method: METHOD_MAP[method] || 'CARD',
    amount: { currency: 'KRW', value: Number(amount) },
    orderId,
    orderName,
    customerName: customerName || '구매자',
    successUrl,
    failUrl,
    windowTarget: 'self',
  });
};

// 결제 승인 (Cloud Function 호출 — 시크릿 키로 토스 confirm)
export const confirmTossPayment = async ({ paymentKey, orderId, amount }) => {
  const res = await fetch(CONFIRM_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ paymentKey, orderId, amount }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || '결제 승인 실패');
  }
  return data;
};

// 결제 환불 (관리자 호출 — Cloud Function 에서 토스 cancel API + 후속 처리)
// cancelAmount 미지정 시 전액 환불
export const refundTossPayment = async ({ paymentKey, orderId, cancelReason, cancelAmount, adminEmail }) => {
  const res = await fetch(REFUND_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ paymentKey, orderId, cancelReason, cancelAmount, adminEmail }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || '환불 실패');
  }
  return data;
};
